import fetchServer from "../../fetchServer";

const BASE_URL = "/product/v1/agent-flight-supplier-settings";

async function getSetting(accountId) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching agent flight supplier settings!",
  };

  await fetchServer({
    method: "GET",
    url: `${BASE_URL}/${accountId}`,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        const payload = res?.data?.data ?? res?.data;
        result = { return: 1, msg: "Successful", data: payload };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}

async function upsertSetting(accountId, data) {
  let result = {
    return: 0,
    msg: "Something went wrong updating agent flight supplier settings!",
  };

  await fetchServer({
    method: "PATCH",
    url: `${BASE_URL}/${accountId}`,
    data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        const payload = res?.data?.data ?? res?.data;
        result = { return: 1, msg: "Successful", data: payload };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}

async function deleteSetting(accountId) {
  let result = {
    return: 0,
    msg: "Something went wrong deleting agent flight supplier settings!",
  };

  await fetchServer({
    method: "DELETE",
    url: `${BASE_URL}/${accountId}`,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        const payload = res?.data?.data ?? res?.data;
        result = { return: 1, msg: "Successful", data: payload };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch(() => {
      console.log("Network Error!");
    });

  return result;
}

const agentSupplierSettingController = {
  getSetting,
  getSeting: getSetting,
  upsertSetting,
  deleteSetting,
};

export default agentSupplierSettingController;
